import { useAdminStore } from "@/store/useAdminStore";
import { FormValues } from "@/types/productTypes";
import createDefaultValues from "@/utils/createDefaultValues";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";

export function useDefaultValues() {
   const { currentProduct } = useAdminStore();
   const [loaded, setLoaded] = useState(false);
   const defaultFormValues = useMemo(() => {
      if (!currentProduct?.stages) return {};
      return {
         ...createDefaultValues(currentProduct.stages),
      };
   }, [currentProduct?.stages]);
   const methods = useForm<FormValues>({
      defaultValues: {
         ...defaultFormValues,
      },
   });

   useEffect(() => {
      if (!currentProduct) {
         return;
      }
      const newDefaults = {
         ...defaultFormValues,
      };
      // Reset form when currentProduct changes
      methods.reset(newDefaults);
      setLoaded((i) => !i);
   }, [currentProduct]);

   return { methods, loaded };
}
